<h1 mat-dialog-title>{{'Add pdf file' | translate}}</h1>
<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>{{'Description' | translate}}:</mat-label>
        <input matInput type="text" [(ngModel)]="value">
        <!-- <button *ngIf="value && !filteredTags.length" matSuffix mat-icon-button aria-label="add" (click)="addTag()">
            <mat-icon>add_circle</mat-icon>
        </button>
        <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
            <mat-icon>close</mat-icon>
        </button> -->
    </mat-form-field>
    <!-- <button mat-raised-button aria-label="Upload" [disabled]="!file || !value" (click)="addPdf()">
        Upload
    </button> -->
    <p>
        <input type="file" accept='.pdf' (change)="onFileChanged($event)" #fileInput>
    </p>
    <!-- <hr>
    <p>Available files:</p>
    <ng-container *ngIf="pdfs">
        <mat-selection-list #shoes [multiple]="false">
            <mat-list-option *ngFor="let pdf of pdfs" [value]="pdf" (click)="selectPdf(pdf)">
                <div class="file-row">
                    <img src="./assets/pdf.png">
                    <span>{{pdf.description}}</span>
                    &nbsp; - &nbsp; <i>[{{pdf.value}}]</i>
                </div>
            </mat-list-option>
        </mat-selection-list>
    </ng-container> -->

</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button aria-label="Upload" [disabled]="!file || !value" (click)="addPdf()">
        {{'Upload' | translate}}
    </button>
</div>